import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Calendar, Badge, List } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import './index.css'
import Clients from "../../clients/list/Clients";

export const noteTypes = [
  {
    id: 0,
    title: 'Information',
    icon: 'info-circle-o',
  },
  {
    id: 1,
    title: 'Consultation',
    icon: 'medicine-box',
  },
  {
    id: 2,
    title: 'Event',
    icon: 'calendar',
  }
]
const dateFormat = 'YYYY-MM-DD'

const ListHeader = () => (
  <Link to={'/schedule/new'}>
    <Button size='large' type='primary' icon='calendar'>Add new</Button>
  </Link>
)

const ListItem = item => (
  <List.Item
    extra={<div>
      {item.clientId && (
        <span>
        <Link to={`/clients/${item.clientId}`}>{item.clientFullName}</Link>
        <br />
      </span>
      )}
      <span>{moment(item.date).format('DD/MM/YY HH:mm')}</span>
    </div>}
  >
    <List.Item.Meta
      title={<Link to={`/schedule/${item._id}`}>{item.noteTitle}</Link>}
      description={item.description}
    />
    </List.Item>
)

const propTypes = {
  list: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired,
  setItemState: PropTypes.func.isRequired,
}

const defaultProps = {
  list: [],
  isFetching: false,
}

export class Schedule extends Component {
  constructor() {
    super()
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleMonthYearChange = this.handleMonthYearChange.bind(this)
    this.dateCellRender = this.dateCellRender.bind(this)
    this.monthCellRender = this.monthCellRender.bind(this)
  }
  componentDidMount() {
    const { getList, item: { date }, history } = this.props
    const momentDate = moment(date)
    const from = momentDate.startOf('month').format(dateFormat)
    const to = momentDate.endOf('month').format(dateFormat)
    history.replace(`/schedule?from=${from}&to=${to}`)
    getList()
  }

  handleMonthYearChange(value, mode) {
    const { getList, history } = this.props
    const momentDate = moment(value)
    const from = momentDate.startOf(mode).format(dateFormat)
    const to = momentDate.endOf(mode).format(dateFormat)
    history.replace(`/schedule?from=${from}&to=${to}`)
    getList()
  }

  handleDateChange(date) {
    const { setItemState, item } = this.props
    setItemState({ ...item, date: date.toDate() })
    if (moment(item.date).month() !== date.month()) {
      this.handleMonthYearChange(date, 'month')
    }
  }

  dateCellRender(value) {
    const { list } = this.props
    const listData = list.filter(d => value.isSame(d.date, 'day'))
    return (
      listData.map(item => (
        <div key={item._id} className={'note-event'}>
          <Icon type={noteTypes[item.noteType].icon} />
          {' '}
          <span>{item.noteTitle}</span>
        </div>
      ))
    )
  }

  monthCellRender(date) {
    const { list } = this.props
    const eventsCount = list.filter(d => date.isSame(d.date, 'month'))
    return eventsCount.length ?
      <Badge
        count={eventsCount.length}
        style={{ backgroundColor: '#108ee9' }}
      /> : null
  }

  render() {
    const { list, item: { date } } = this.props
    const filtredList = list.filter(d => moment(date).isSame(moment(d.date), 'day'))
    return (
      <div className='schedule'>
        <Calendar
          onSelect={this.handleDateChange}
          onPanelChange={this.handleMonthYearChange}
          dateCellRender={this.dateCellRender}
          monthCellRender={this.monthCellRender}
        />
        <List
          header={<ListHeader />}
          bordered
          dataSource={filtredList}
          renderItem={ListItem}
        />
      </div>
      )
  }
}

Schedule.propTypes = propTypes
Schedule.defaultProps = defaultProps
export default Schedule



// WEBPACK FOOTER //
// ./src/containers/schedule/list/Schedule.js